<template>
    <div class="alert-box" :style="{ color: alertBoxFontColor, background: alertBoxBackgroundColor }">
        <slot></slot>
    </div>
</template>

<script>
export const AlertBoxType = Object.freeze({
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    DISABLED: 'DISABLED',
    ERROR: 'ERROR'
})

export const AlertBoxColor = Object.freeze({
    SUCCESS: '#28B18F',
    WARNING: '#BB8340',
    DISABLED: '#9E9E9E',
    ERROR: '#E76666',
})

export const AlertBoxBackgroundColor = Object.freeze({
    SUCCESS: '#D3F5ED',
    WARNING: '#F4CFA2',
    DISABLED: '#E7E7E7',
    ERROR: '#FFD8DF',
})

export default {
    name: 'AlertBox',
    props: {
        type: {
            type: String,
            default: AlertBoxType.SUCCESS
        },
    },
    computed: {
        typeUppercased() {
            return this.type.toUpperCase()
        },
        alertBoxFontColor() {
            return AlertBoxColor[this.typeUppercased]
        },
        alertBoxBackgroundColor() {
            return AlertBoxBackgroundColor[this.typeUppercased]
        }
    }
}
</script>

<style lang="scss" scoped>
.alert-box {
    background: #D3F5ED;
    border-radius: 2px;
    padding: 18px 24px;
    color: #28B18F;
    font-weight: 500;
}
</style>
